<template>
  <div class="speakers-list">
    <div>
      <h3>For</h3>
      <div>
        <speakers-list-item
          v-for="speaker in motion.for"
          :speaker="speaker"
          :key="speaker.id" class="p-d-flex" />
        <div class="empty-state" v-if="!motion.for.length">
          <em>n/a</em>
        </div>
      </div>
      <h3>Against</h3>
      <div>
        <speakers-list-item
          v-for="speaker in motion.against"
          :speaker="speaker"
          :key="speaker.id" class="p-d-flex" />
        <div class="empty-state" v-if="!motion.against.length">
          <em>n/a</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpeakersListItem from './SpeakersListItem.vue'

export default {
  name: 'SpeakersList',
  components: {
    SpeakersListItem
  },
  props: {
    motion: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/speakers/SpeakersList.vue